import { Project } from '../types';

const project: Project = {
  slug: 'puerta-cortes',
  accessPin: '5580',
  qrTickets: ['P5C9H1'],
  info: {
    id: 5,
    title: 'Puerta Cortes',
    category: {
      'en-US': 'Renovation',
      'es-MX': 'Renovacion',
    },
    year: 2024,
    location: 'Desarrollo Puerta Cortes, Mexico.',
    floor: '1 floors',
    building: '650aZA-',
    cover: '/images/Cover5.webp',
    description: {
      'en-US':
        'The renovation of the main entrance gate to Puerta Cortes Development in La Paz, B.C.S., aimed to enhance the arrival experience with a refined and contemporary architectural gesture. The intervention emphasizes clean lines, regional stone textures, and minimalistic volumetry to reflect the elegance of the coastal resort it serves.',
      'es-MX':
        'La renovacion del acceso principal a Puerta Cortes en La Paz, B.C.S., busca mejorar la experiencia de llegada con un gesto arquitectonico contemporaneo y sobrio. La intervencion enfatiza lineas limpias, texturas de piedra regional y volumetria minimalista para reflejar la elegancia del resort costero al que sirve.',
    },
  },
  assets: {
    images: [
      { file: '5.1', ext: 'webp' },
      { file: '5.2', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
